import { getPublicNews, getHostPolicy } from "@/api/panel";

function renderNews(data) {
  if (!data || !data.length) return [];
  return data.map(item => ({
    ...item,
    pic: [item.coverUrl],
    id: item.newsId,
    news_title: item.newsTitle,
    post_time: item.newsTime.slice(0, 11)
  }));
}

export default {
  namespaced: true,
  state: {
    news: [],
    policy: []
  },
  mutations: {
    SET_NEWS: (state, data) => {
      state.news = data || [];
    },
    SET_POLICE: (state, data) => {
      state.policy = data || [];
    }
  },
  actions: {
    getPublicNews({ commit, state }, data) {
      if (state.news.length > 0) return;
      getPublicNews(data).then(response => {
        const { data } = (response && response.data) || {};
        if (data) commit("SET_NEWS", renderNews(data) || {});
      });
    },

    getHostPolicy({ commit, state }) {
      if (state.policy.length > 0) return;
      getHostPolicy({}).then(response => {
        const { data } = (response && response.data) || {};
        commit("SET_POLICE", data);
      });
    }
  }
};
